import EditRowRisk from './EditRowRisk/EditRowRisk'
import RiskCategoryRow from './RiskCategoryRow'
import AddCategoryRow from './AddCategoryRow/AddCategoryRow'

export const EditRowRiskComponent = EditRowRisk
export const RiskCategoryRowComponent = RiskCategoryRow
export const AddCategoryRowComponent = AddCategoryRow
